<template>
    <div class="p-5" v-if="!$global.loading">
        <div v-if="criteriaFamilies.length === 0" class="text-center d-flex flex-column">
            <div>
                <button class="text-center cadh-add-button" @click="createPredefinedFamily">
                    <span class="font-weight-bold h4">
                        + <br>
                        Ajouter une <br>
                       question
                    </span>
                </button>
            </div>

            <div class="mt-2">
                <a href="https://www.loom.com/share/39c1afd116a84c6fb54d616857c1fcd1" target="_blank">
                    C'est quoi ?
                    <v-icon color="primary">open_in_new</v-icon>
                </a>
            </div>
        </div>

        <div v-else class="d-flex justify-content-between adhesion-top-alert">
            <v-alert type="info"
                     text
                     class="container m-0 mr-3">
                Dans cet espace vous pouvez définir des questions et des réponses qui permettent de filtrer les offres
                présentées au prestataire.
                Il faudra ensuite définir quelles offres sont associées aux réponses dans la section offre.
                <a href="https://www.loom.com/share/39c1afd116a84c6fb54d616857c1fcd1" target="_blank">
                    Voir plus d'explication sur les questions.
                </a>
            </v-alert>

            <v-btn class="default-button text-none" @click="createFamily">
                <v-icon class="mr-1" color="white" dense>
                    add
                </v-icon>
                Ajouter une question
            </v-btn>
        </div>

        <draggable v-model="families"
                   handle=".drag-handle-2"
                   :options="{
                        animation: 200,
                        ghostClass: 'sortable-ghost',
                        chosenClass: 'sortable-chosen'
                   }"
                   @start="setCopyFamilies"
                   @change="reorderFamily"
                   :scroll-sensitivity="200"
                   :force-fallback="true">
            <question v-for="family in families"
                    :family="family"
                    class="mt-4 d-flex justify-content-between">
            </question>
        </draggable>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import draggable from 'vuedraggable'
import _ from 'lodash'
import Question from "./Question.vue"

export default {
    name: "QuestionTab",
    components: {Question, draggable},
    data() {
        return {
            copyFamilies: []
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setCurrentStep", "setCadhConfig"]),
        createFamily() {
            let order = this.families.length > 0 ? this.families[this.families.length -1].order + 1 : 1

            let payload = {
                configId: this.cadhConfig.id,
                order: order
            }

            this.$store.dispatch("cadhConfig/createCriteriaFamily", payload).then(() => {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    left: 0,
                    behavior: "smooth"
                })
            })
        },
        createPredefinedFamily() {
            let payload = {
                'configId': this.cadhConfig.id
            }

            this.$store.dispatch("cadhConfig/createPredefinedFamily", payload)
        },
        setCopyFamilies(event) {
            this.copyFamilies = JSON.parse(JSON.stringify(this.families))
        },
        reorderFamily(event) {
            if (event.moved) {
                const pointerType = event.moved.newIndex !== this.families.length - 1 ? 'before' : 'after'
                const moveObject = event.moved.element.id
                const pointerId = this.copyFamilies[event.moved.newIndex].id

                this.$store.dispatch('cadhConfig/reorderList', [
                    'cadh_criteria_families',
                    this.cadhConfig.id,
                    pointerId,
                    pointerType,
                    moveObject
                ]).then(res => {
                    this.$store.commit('cadhConfig/setCriteriaFamilies', res.body.data.items)
                })
            }
        }
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "criteriaFamilies"]),
        families: {
            get() {
                return this.criteriaFamilies
            },
            set(value) {
                this.$store.commit('cadhConfig/setCriteriaFamilies', value)
            }
        }
    }
}
</script>